import { Component, OnInit } from '@angular/core';
import { AgreementBtnComponent } from '../../components/agreement-btn/agreement-btn.component';
import { LogoComponent } from '../../../global/components/logo/logo.component';
import { LOGO } from '../../../../helpers/constants';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { LucideAngularModule, Ship } from 'lucide-angular';
import { animate, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-user-agreement-page',
  standalone: true,
  imports: [
    AgreementBtnComponent,
    LogoComponent,
    CommonModule,
    ButtonModule,
    LucideAngularModule,
  ],
  templateUrl: './user-agreement-page.component.html',
  styleUrl: './user-agreement-page.component.css',
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate(
          '300ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
      transition(':leave', [
        animate(
          '200ms ease-in',
          style({ opacity: 0, transform: 'translateY(-10px)' })
        ),
      ]),
    ]),
  ],
})
export class UserAgreementPageComponent implements OnInit {
  logo: string = LOGO;
  isChecked: boolean = false;
  readonly arrowRight = Ship;

  jobId!: string;

  captainText: string = 'Lets Find Your Captain!';

  constructor(private router: Router, private route: ActivatedRoute) {}
  ngOnInit() {
    this.jobId = this.route.snapshot.paramMap.get('jobId') || '';
  }

  onCheckedChange(isChecked: boolean) {
    this.isChecked = isChecked;
  }

  routeToTracking() {
    this.router.navigate(['tracking', this.jobId]);
  }
}
